export const sliderImages = () => {
  return [
    {
      src: "/assets/01.jpg",
    },
    {
      src: "/assets/02.jpg",
    },
    {
      src: "/assets/03.jpg",
    },
    {
      src: "/assets/04.jpg",
    },
    // {
    //   src: "/assets/05.jpg",
    // },
    // {
    //   src: "/assets/06.jpg",
    // },
  ];
};
